import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import PropTypes from "prop-types";
import { Flex } from "@base-ui";
import FormattedText from "@cms/components/ui/FormattedText";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["layout", "flexbox", "space"];
var Quote = function Quote(props) {
  var quote = props.quote,
    inverted = props.inverted,
    _props$textAlign = props.textAlign,
    textAlign = _props$textAlign === void 0 ? "center" : _props$textAlign;
  return /*#__PURE__*/_jsx(Flex.Column, _objectSpread(_objectSpread({
    inverted: inverted,
    height: "100%",
    p: "40px"
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: /*#__PURE__*/_jsx(FormattedText, {
      delta: quote.formattedText,
      inverted: inverted,
      textAlign: textAlign,
      m: "auto"
    })
  }));
};
Quote.propTypes = {
  quote: PropTypes.object,
  inverted: PropTypes.bool
};
export default /*#__PURE__*/memo(Quote);